export default __webpack_public_path__ + "static/media/hhs-qld-wide-bay.62d9e3fa.svg";